export default {
  Success: 1,
  Error: 2,
  NoData: 3,
};
